import React, { Fragment, PureComponent } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import IconButton from '@mui/material/IconButton';
import {
	FormGroup,
	Label,
	Input,
} from 'reactstrap';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import {   
    allStudents,
    addInjuryUpdate,
    allSSTeam,
    deleteInjuryUpdate,
    editInjuryUpdate
 } from 'Actions';



class UpdateElements extends React.Component {
   
    static propTypes = {
        classes: PropTypes.object,
        prev:0,
    };

    static num1 = 0;

    UNSAFE_componentWillMount() {
		this.props.allStudents();  
        this.props.allSSTeam();
	}
   constructor(props) {
        
      super(props);
      this.confirmationDialog = React.createRef();
      this.state = {
            student: '',
            quarter:'',
            seldate:new Date(),
            adddiv:true,
            editdiv:false, 
            eid:'',           
            sicid:this.props.data.injuryid,
            edseldate:'',
            teamid:'',
            provisional_diagnosis:'',
            injury_severity:'',
            update_rehabilitation:'',
            plan_action:'',
            note_sc_team:'',
            note_coaching_team:'',
            note_tsg_team:''
         };
         this.deleteTeam = this.deleteTeam.bind(this); 
         this.editTeam = this.editTeam.bind(this);
         this.onBackAdd = this.onBackAdd.bind(this);
   }
   
   

    selectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD HH:mm');
        this.setState({ seldate:date });
        
        
    }

    edselectdate = (date) => {
        const seldate =moment(new Date(date)).format('yyyy-MM-DD HH:mm');
        this.setState({ edseldate:date });
        
        
    }    

    addHandleSubmit(event){
        event.preventDefault();
        var sicid=this.state.sicid;
        this.props.addInjuryUpdate(event,sicid).then((data) => {   
           
            if(data.status==1){                    
                    document.getElementById("addassessmentform").reset();
                    //setTimeout(this.props.onClick, 5000);
            }
        });
        
    }   

    editHandleSubmit(event){
        event.preventDefault();
        var sicid=this.state.sicid;
        var eid=this.state.eid;
        this.props.editInjuryUpdate(event,eid,sicid).then((data) => {   
           
            
        });
        
    }   
    
    
    deleteTeam(data){

        this.data = data;
        this.scid= this.state.sicid;
        this.confirmationDialog.current.openDialog();
    }

    deleteDataPermanent(popupResponse){
        
        if (popupResponse) {
            this.props.deleteInjuryUpdate(this.data,this.scid);
            this.data = ""
        }
    }

   editTeam(rawdata){     
    const seldate =new Date(rawdata.siu_date);
      this.setState({
        eid:rawdata.siuID,
        edseldate:seldate,
        teamid:rawdata.siu_teamID,
        provisional_diagnosis:rawdata.siu_provisional_diagnosis,
        injury_severity:rawdata.siu_injury_severity,
        update_rehabilitation:rawdata.siu_update_rehabilitation,
        plan_action:rawdata.siu_plan_action,
        note_sc_team:rawdata.siu_note_sc_team,
        note_coaching_team:rawdata.siu_note_coaching_team,
        note_tsg_team:rawdata.siu_note_tsg_team,    
         adddiv:false,
         editdiv:true
      });
   }

   onBackAdd(){
        this.setState({                
            adddiv:true,
            editdiv:false
        });
   }
   
  
   handleInput(event) {
    const bullet = "\u2022";
    const inputValue = event.target.value;
    const cursorPosition = event.target.selectionStart;
    let lines = inputValue.split('\n');
  
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      if (!line.trim().startsWith(bullet)) {
        lines[i] = `${bullet} ${line.trimLeft()}`;
      }
    }
  
    let newValue = lines.join('\n');
    if (event.nativeEvent.inputType === 'deleteContentBackward') {
      if (cursorPosition === 0) {
        const lineIndex = newValue.substr(0, cursorPosition).split('\n').length - 1;
        if (lineIndex > 0) {
          const linesArray = newValue.split('\n');
          linesArray.splice(lineIndex, 1);
          newValue = linesArray.join('\n');
        }
      } else if (newValue[cursorPosition - 1] === bullet && (cursorPosition === newValue.length || newValue[cursorPosition] === '\n')) {
        newValue = newValue.slice(0, cursorPosition - 2) + newValue.slice(cursorPosition);
      }
    }
  
    event.target.value = newValue;
  
    this.setState({
      previousLength: newValue.length,
    });
  }
  

   render() {
      
      const { studentlists, ssteamlists, injuryupdatelists, loading} = this.props;

      const allstudent=studentlists.map((stdval) => {  
            return {
               label: stdval.student,  
               value: stdval.uudID
            }
      });

   

      return (
            <div>
                <div className="row">
                    <div className="col-sm-12 col-lg-12">
                       <div className="col-lg-4" style={{margin:"0 auto"}}>
                        <button type="button" className="mr-3 mb-3 btn btn-outline-success" onClick={this.props.onClick} >Back to Injury List</button> 
                       </div> 
                    </div>
                    <div className="col-sm-12 col-lg-6">
                        <RctCollapsibleCard heading="List of Injury Updates">
                            <div className="table-responsive">
                                <Table hover bordered striped>
                                    <thead>
                                        <tr className="bg-primary text-white">
                                            <th>Sl.No</th>
                                            <th>Assessor</th>
                                            <th>Date</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>                              
                                    {injuryupdatelists.map((teamval,idx) => (
                                        <tr key={idx}>
                                            <td>{idx + 1}</td>
                                            <td>{teamval.sc_name}</td>
                                            <td>{teamval.cdate}</td>
                                            <td>
                                            <IconButton className="text-info" aria-label="edit" onClick={ ()=>this.editTeam(teamval)}><EditOutlinedIcon/></IconButton>
                                            <IconButton className="text-danger" aria-label="Delete" onClick={ ()=>this.deleteTeam(teamval.siuID)}><DeleteOutlineOutlinedIcon/></IconButton> 
                                            </td>
                                        </tr>
                                    ))}
                                                            
                                    </tbody>
                                </Table>
                            </div>
                        </RctCollapsibleCard>
                    </div>
                    {this.state.adddiv && 
                        <div className="col-sm-12 col-lg-6">
                            <form autoComplete="off" id="addassessmentform" onSubmit={(e)=>this.addHandleSubmit(e)}>
                                <div className="row">                            
                                    <RctCollapsibleCard heading="Add Injury Update">   
                                                                        
                                            <div className="row">
                                                <div className="col-sm-12 col-lg-8">   
                                                    <FormGroup>
                                                        <Label for="Select">Assessor Name *</Label>
                                                            <select name="teamid" id="teamid" className="form-control form-control-alternative" required>
                                                                <option value=""></option>
                                                                {ssteamlists.map((teamval) => (   
                                                                    teamval.sc_status==1 ?                                                       
                                                                    <option value={teamval.sctID}>{teamval.sc_name}</option>  
                                                                    :''                                                            
                                                                ))}
                                                            </select>
                                                    </FormGroup>  
                                                </div>     
                                                
                                                <div className="col-sm-12 col-lg-6 col-xl-6">
                                                    <FormGroup>
                                                        <Label for="Email-3">Select Date *</Label>
                                                        <DatePicker className="form-control" id="seldate"  name="seldate" autoComplete="off" required
                                                                selected={this.state.seldate}
                                                                onChange={this.selectdate}
                                                                dateFormat='yyyy-MM-dd HH:mm'
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                timeFormat="HH:mm"
                                                                timeIntervals={10}
                                                                showTimeSelect
                                                                dropdownMode="select"
                                                            /> 
                                                    </FormGroup>                                          
                                                </div>                                            
                                                <div className="col-sm-12 col-lg-6 col-xl-12">
                                                    <FormGroup>
                                                        <Label for="Select">Provisional Diagnosis</Label>
                                                        <textarea rows="4" type="text" name="provisional_diagnosis" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label for="Select">Injury Severity</Label>
                                                        <textarea rows="4" type="text" name="injury_severity" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                                    </FormGroup>                                                 
                                                    <FormGroup>
                                                        <Label for="Select">Update on Rehabilitation *</Label>
                                                        <textarea rows="4" type="text" name="update_rehabilitation" required className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                                    </FormGroup> 
                                                    <FormGroup>
                                                        <Label for="Select">Plan Of Action *</Label>
                                                        <textarea rows="4" type="text" name="plan_action" required className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                                    </FormGroup> 
                                                    <FormGroup>
                                                        <Label for="Select">Note for S&C Team</Label>
                                                        <textarea rows="4" type="text" name="note_sc_team" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                                    </FormGroup> 
                                                    <FormGroup>
                                                        <Label for="Select">Note For Coaching Team</Label>
                                                        <textarea rows="4" type="text" name="note_coaching_team"  className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                                    </FormGroup> 
                                                    <FormGroup>
                                                        <Label for="Select">Note For Team TSG</Label>
                                                        <textarea rows="4" type="text" name="note_tsg_team" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                                    </FormGroup>                                             
                                                </div>
                                                    <div className="form-group">
                                                        <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                                                    </div>
                                                    
                                            </div>
                                    </RctCollapsibleCard> 
                                </div>    
                            </form> 
                        </div>
                    }
                    {this.state.editdiv && 
                        <div className="col-sm-12 col-lg-6">
                            <form autoComplete="off" id="editassessmentform" onSubmit={(e)=>this.editHandleSubmit(e)}>
                                <div className="row">                            
                                    <RctCollapsibleCard heading="Edit Injury Update">   
                                                                        
                                            <div className="row">
                                                <div className="col-sm-12 col-lg-8">   
                                                    <FormGroup>
                                                        <Label for="Select">Assessor Name *</Label>
                                                            <select name="teamid" id="teamid" defaultValue={this.state.teamid} className="form-control form-control-alternative" required>
                                                                <option value=""></option>
                                                                {ssteamlists.map((teamval) => (   
                                                                    teamval.sc_status==1 ?                                                       
                                                                    <option value={teamval.sctID}>{teamval.sc_name}</option>  
                                                                    :''                                                            
                                                                ))}
                                                            </select>
                                                    </FormGroup>  
                                                </div>     
                                                
                                                <div className="col-sm-12 col-lg-6 col-xl-6">
                                                    <FormGroup>
                                                        <Label for="Email-3">Select Date *</Label>
                                                        <DatePicker className="form-control" name="seldate" autoComplete="off" required
                                                                selected={this.state.edseldate}
                                                                onChange={this.edselectdate}
                                                                dateFormat='yyyy-MM-dd HH:mm'
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                                timeFormat="HH:mm"
                                                                timeIntervals={10}
                                                                showTimeSelect
                                                                dropdownMode="select"
                                                            /> 
                                                    </FormGroup>                                          
                                                </div>                                            
                                                <div className="col-sm-12 col-lg-6 col-xl-12">
                                                    <FormGroup>
                                                        <Label for="Select">Provisional Diagnosis</Label>
                                                        <textarea rows="4" type="text" name="provisional_diagnosis" defaultValue={this.state.provisional_diagnosis} id="provisional_diagnosis" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                                    </FormGroup>
                                                    <FormGroup>
                                                        <Label for="Select">Injury Severity</Label>
                                                        <textarea rows="4" type="text" name="injury_severity" defaultValue={this.state.injury_severity} id="injury_severity" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                                    </FormGroup>                                                 
                                                    <FormGroup>
                                                        <Label for="Select">Update on Rehabilitation *</Label>
                                                        <textarea rows="4" type="text" name="update_rehabilitation" defaultValue={this.state.update_rehabilitation} id="update_rehabilitation" required className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                                    </FormGroup> 
                                                    <FormGroup>
                                                        <Label for="Select">Plan Of Action *</Label>
                                                        <textarea rows="4" type="text" name="plan_action" defaultValue={this.state.plan_action} id="plan_action" required className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                                    </FormGroup> 
                                                    <FormGroup>
                                                        <Label for="Select">Note for S&C Team</Label>
                                                        <textarea rows="4" type="text" name="note_sc_team" defaultValue={this.state.note_sc_team} id="note_sc_team" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                                    </FormGroup> 
                                                    <FormGroup>
                                                        <Label for="Select">Note For Coaching Team</Label>
                                                        <textarea rows="4" type="text" name="note_coaching_team" defaultValue={this.state.note_coaching_team} id="note_coaching_team" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                                    </FormGroup> 
                                                    <FormGroup>
                                                        <Label for="Select">Note For Team TSG</Label>
                                                        <textarea rows="4" type="text" name="note_tsg_team" defaultValue={this.state.note_tsg_team} id="note_tsg_team" className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                                                    </FormGroup>                                             
                                                </div>
                                                    <div className="form-group">
                                                        <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Update" />
                                                        <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.onBackAdd} value="Back" />
                                                    </div>
                                                    
                                            </div>
                                    </RctCollapsibleCard> 
                                </div>    
                            </form> 
                        </div>
                    }
                    <ConfirmationDialog
                        ref={this.confirmationDialog}
                        onConfirm={(res) => this.deleteDataPermanent(res)}
                        data={'injury update'}
                        />
                </div>
            </div>
      );
   }
}


const mapStateToProps = ({ mostlyused, ssteam, injurychart }) => {
    const { studentlists, loading } = mostlyused;
    const { ssteamlists } = ssteam;
    const { injuryupdatelists } = injurychart;
    return { studentlists, ssteamlists, injuryupdatelists, loading };
}

export default connect(mapStateToProps, {
    allStudents,
    addInjuryUpdate,
    allSSTeam,
    deleteInjuryUpdate,
    editInjuryUpdate
})(UpdateElements); 